
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {challengeModule, challengesState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ChallengesSituationsTemplate from '@/components/Challenges/ChallengesSituationsTemplate.vue';

  @Component({
    components: {ChallengesSituationsTemplate}
  })
  export default class ChallengesAnySituation extends Vue {
    @challengeModule.Getter('challenges') challenges!: ChallengeModel[];
    @challengeModule.Getter('challengesByTag') challengesByTag!: (tag: string) => ChallengeModel[];
    @challengeModule.Getter('lastPage') lastPage!: number;
    @challengeModule.Getter('currentPage') page!: number;
    @challengeModule.Getter('loading') loading!: boolean;

    get tag(): string | null {
      return this.$route.query?.tag?.toString() || null
    }

    get emptyMessage(): string {
      return !!this.tag ? this.$t('challenge.labels.no_challenge_registered_with_tag', [this.tag]).toString() : this.$t('challenge.labels.no_challenge_registered').toString()
    }

    get challengesFiltered(): ChallengeModel[] {
      if (this.tag) {
        return this.challengesByTag(this.tag)
      }
      return this.challenges
    }

    async mounted() {
      this.makeRequest(1);
    }

    async inBottom() {
      if ((this.page < this.lastPage) && !this.loading) {
        this.makeRequest(this.page + 1);
      }
    }

    private async makeRequest(page: number) {
      const tag = this.$route.query?.tag?.toString();
      await challengesState.fetchAll({
        page: page,
        tag,
      });
    }
  }
